export const DIALOG_REPORT_MOD_COMPLETE_TITLE = `Спасибо! Сообщение о проблеме отправлено`

export const DIALOG_REPORT_MOD_COMPLETE_CONTENT = `Мы обязательно проверим этот мод на наличие проблем. Благодарим вас за бдительность.`

export const DIALOG_REPORT_MOD_COMPLETE_OK_BUTTON = `Закрыть`
